<template>
	<div class="landing-page faqs">

		<!-- Top navbar -->
		<landing-page-navbar></landing-page-navbar>

		<div class="content-container" v-if="carrierDetails">
			<!-- Hero banner -->
			<div class="hero-banner">
				<div class="container">
					<h1>Help centre</h1>
					<div class="search-input-container">
						<div class="input-group search-input-group icon-prepend">
							<input type="text" class="form-control search-input" placeholder="Search FAQs" v-model="search">
							<span class="input-group-addon input-clear" @click="clearSearch" v-if="search"></span>
							<span class="input-group-prepend search">
								<i class="fa fa-search"></i>
							</span>
							<div class="faq-search-results" v-if="search">
								<ul class="list-unstyled" v-if="searchResults.length > 0">
									<li v-for="(result, index) in searchResults" :key="index">
										<a :href="searchResultLink(result) + `/#${result.id}`" @click="goToFaq()">
											<span v-html="result.question"></span>
										</a>
									</li>
								</ul>
								<div class="empty-state" v-if="searchResults.length === 0">
									<i class="fa fa-search"></i>
									<p>
										No results found for that search
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Manage Booking Search Banner -->
			<manage-booking-search-banner></manage-booking-search-banner>

			<!-- Categories -->
			<div class="faq-categories">
				<div class="container pb-0 ">
					<h3>Select a help category</h3>
					<div class="card-grid grid-col-sm-2 grid-col-md-3">
						<div class="card-link-container" v-for="(category, index) in categories" :key="index">
							<router-link :to="{'name': category.link}" class="card card-link horizontal">
								<div class="card-body">
									<component :is="category.icon" size="3x"></component>
									<span v-html="category.title"></span>
								</div>
							</router-link>
						</div>
					</div>
				</div>
			</div>

			<!-- Popular Questions -->
			<div class="popular-questions">
				<div class="container">
					<div class="row">
						<div class="col-md-12">
							<h3>Our most popular questions</h3>
							<div class="accordion" role="tablist">
								<b-card no-body v-for="(faq, index) in popularFaqs" :key="index">
									<b-card-header header-tag="header" role="tab" v-b-toggle="`popular-question-${index}`">
										<span v-html="faq.question"></span>
									</b-card-header>
									<b-collapse :id="`popular-question-${index}`" role="tabpanel" accordion="faq-accordion">
										<b-card-body>
											<p v-html="faq.answer"></p>
										</b-card-body>
									</b-collapse>
								</b-card>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Help Banner -->
			<div class="container">
				<faq-contact-banner></faq-contact-banner>
			</div>

		</div>
		<!-- Footer -->
		<page-footer></page-footer>
	</div>
</template>

<script>
if (process.env.VUE_APP_PARTNER_ENVIRONMENT) {
	require('@/styles/core/whitelabel/'+process.env.VUE_APP_PARTNER_ENVIRONMENT+'.scss');
} else {
	require('@/styles/core/whitelabel/wefix.scss');
}

import {mapActions, mapGetters} from "vuex";

export default {
	name: "FaqsIndex",

	data() {
		return {
			categories: [
				{
					title: "Booking",
					icon: "icon-calendar",
					link: "BookingFaqs"
				},
				{
					title: "The repair",
					icon: "icon-tools",
					link: "RepairFaqs"
				},
				{
					title: "Pricing &amp; payments",
					icon: "icon-payment-card",
					link: "PaymentsFaqs"
				},
				{
					title: "Likewize Repair guarantee",
					icon: "icon-warranty",
					link: "GuaranteeFaqs"
				},
				{
					title: "Where is Likewize Repair?",
					icon: "icon-location",
					link: "LocationFaqs"
				},
				{
					title: "Terms &amp; privacy",
					icon: "icon-terms",
					link: "TermsFaqs"
				}
			],
			search: ""
		}
	},

	computed: {
		...mapGetters([
			'allFaqs',
			'bookingFaqs',
			'carrier',
			'carrierDetails',
			'guaranteeFaqs',
			'locationFaqs',
			'partnerEnvironment',
			'paymentFaqs',
			'popularFaqs',
			'repairFaqs',
			'termsFaqs'
		]),

		searchResults() {
			if (!this.search) {
				return [];
			}
			let data = [];
			for (let i in this.allFaqs) {
				data.push(this.allFaqs[i]);
			}
			let faqCategories = [].concat(...Object.values(data));
			return faqCategories.filter(faq => {
				if (faq.question && faq.answer && this.search) {
					return faq.question.toLowerCase().includes(this.search.toLowerCase()) || faq.answer.toLowerCase().includes(this.search.toLowerCase());
				}
			});
		},
	},

	methods: {
		...mapActions([
			'setCarrier'
		]),

		/** Clears the text in the search field **/
		clearSearch() {
			this.search = ""
		},

		/** When clicking an FAQ link, we clear the text in the search field (a Shaun dirty hack special) **/
		goToFaq() {
			setTimeout(() => {
				this.clearSearch()
			}, 250)
		},

		/** Link search result to the correct page **/
		searchResultLink(result) {
			switch (result.category) {
				case "booking":
					return "/faqs/booking";
				case "guarantee":
					return "/faqs/guarantee";
				case "location":
					return "/faqs/location";
				case "payments":
					return "/faqs/payments";
				case "repair":
					return "/faqs/repair";
				case "terms":
					return "/faqs/terms";
			}
		}
	}
}
</script>

<style scoped>

</style>